import React from "react";

interface SettingsTabButtonProps {
  tab: "habits" | "features" | "data";
  label: string;
  isActive: boolean;
  onClick: (tab: "habits" | "features" | "data") => void;
}

export const SettingsTabButton: React.FC<SettingsTabButtonProps> = ({
  tab,
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      onClick={() => onClick(tab)}
      style={{
        flex: 1,
        padding: "12px",
        backgroundColor: isActive ? "#007bff" : "transparent",
        color: isActive ? "#fff" : "#000",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 500,
      }}
    >
      {label}
    </button>
  );
};